import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/admin/company/:companyId/users',
    name: 'adminUsers',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "admin-users" */ './views/users.vue')
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        handleRoute()
        function handleRoute() {
          const { companyId } = routeTo.params
          store.dispatch('adminUsers/setCompanyId', { companyId })
          store
            // fetch admin users
            .dispatch('adminUsers/fetchLists', { companyId })
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'adminUsers' } })
            })
        }
      },
    },
  },
  {
    path: '/admin/company/:companyId/users/add',
    name: 'adminUsersAdd',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "admin-add-users" */
          './views/add-users.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/admin/company/:companyId/users/edit/:userId',
    name: 'adminUsersEdit',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "edit-users" */ './views/edit-users.vue')
      ),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      companyId: route.params.companyId,
      userId: route.params.userId,
    }),
  },
]
